module.exports = __webpack_public_path__ + "assets/img/btn-detail-ad611917.png";